// frontend/src/pages/LoginPage.js
import { useState } from 'react';
import { supabase } from '../supabase';
import { useNavigate } from 'react-router-dom';
 
export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
 
  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
 
    const fn = isSignUp
      ? supabase.auth.signUp({ email, password })
      : supabase.auth.signInWithPassword({ email, password });
 
    const { error } = await fn;
    if (error) return setError(error.message);
    navigate('/');
  }
 
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>AI-901 Exam Prep</h1>
        <h2 style={styles.subtitle}>{isSignUp ? 'Create Account' : 'Sign In'}</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input style={styles.input} type='email' placeholder='Email'
            value={email} onChange={e => setEmail(e.target.value)} required />
          <input style={styles.input} type='password' placeholder='Password'
            value={password} onChange={e => setPassword(e.target.value)} required />
          <button style={styles.button} type='submit'>
            {isSignUp ? 'Create Account' : 'Sign In'}
          </button>
        </form>
        <p style={styles.toggle} onClick={() => setIsSignUp(!isSignUp)}>
          {isSignUp ? 'Already have an account? Sign in' : 'No account? Sign up free'}
        </p>
      </div>
    </div>
  );
}
 
const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center',
               justifyContent: 'center', background: '#f0f4f8' },
  card: { background: '#fff', padding: '40px', borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '360px' },
  title: { textAlign: 'center', color: '#1E3A5F', marginBottom: '4px' },
  subtitle: { textAlign: 'center', color: '#555', fontWeight: 'normal', marginBottom: '24px' },
  input: { width: '100%', padding: '12px', marginBottom: '16px', borderRadius: '8px',
           border: '1px solid #ccc', fontSize: '16px', boxSizing: 'border-box' },
  button: { width: '100%', padding: '14px', background: '#1E3A5F', color: '#fff',
            border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' },
  error: { color: 'red', marginBottom: '12px', fontSize: '14px' },
  toggle: { textAlign: 'center', color: '#1E3A5F', cursor: 'pointer', marginTop: '16px', fontSize: '14px' }
};
